import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "timeIconTime" }
const _hoisted_2 = {
  key: 0,
  class: "depart"
}
const _hoisted_3 = { class: "srOnly" }
const _hoisted_4 = {
  key: 0,
  class: "delayedTime"
}
const _hoisted_5 = { class: "srOnly" }
const _hoisted_6 = { class: "arrow-column" }
const _hoisted_7 = {
  key: 2,
  class: "arrive"
}
const _hoisted_8 = { class: "srOnly" }
const _hoisted_9 = { class: "srOnly" }
const _hoisted_10 = {
  key: 0,
  class: "delayedTime"
}
const _hoisted_11 = { class: "srOnly" }
const _hoisted_12 = {
  key: 0,
  class: "duration"
}
const _hoisted_13 = ["aria-label"]

import { formatInTimeZone } from 'date-fns-tz';
import { Skeletor } from 'vue-skeletor';
import { computed } from 'vue';
import { timezone } from '../../envVariables';
import { Icon } from '../../Atoms';
import { calculateDuration } from '../../helpers';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeIconTime',
  props: {
    departureTime: {},
    arrivalTime: {},
    isDelayed: { type: Boolean },
    delayedDepartureTime: {},
    delayedArrivalTime: {},
    isCancelled: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const sailingDuration = computed(() => calculateDuration(props.departureTime, props.arrivalTime));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              class: _normalizeClass([{ delayed: _ctx.isDelayed, cancelled: _ctx.isCancelled }, "time"])
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('Departing at')), 1),
              _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.departureTime, _unref(timezone), 'HH:mm')), 1)
            ], 2),
            (_ctx.isDelayed && _ctx.delayedDepartureTime)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('Delayed departure time')), 1),
                  _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.delayedDepartureTime, _unref(timezone), 'HH:mm')), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 1 }))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Icon), { "icon-name": "arrowRight" })
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: _normalizeClass([{ delayed: _ctx.isDelayed, cancelled: _ctx.isCancelled }, "time"])
              }, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Arriving at')), 1),
                _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.arrivalTime, _unref(timezone), 'HH:mm')), 1)
              ], 2),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isCancelled ? "is cancelled" : "") + " " + _toDisplayString(_ctx.isDelayed ? "is delayed" : ""), 1),
              (_ctx.isDelayed && _ctx.delayedArrivalTime)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Delayed arrival time')), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(formatInTimeZone)(_ctx.delayedArrivalTime, _unref(timezone), 'HH:mm')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(Icon), { "icon-name": "clock" }),
                  _createElementVNode("span", {
                    class: "durationText",
                    "aria-label": sailingDuration.value.replace('m', 'mins').replace('h', 'hr'),
                    role: "text"
                  }, _toDisplayString(sailingDuration.value), 9, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(Skeletor), { key: 3 }))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})